var render, staticRenderFns
import script from "./ContentNode.vue?vue&type=script&lang=js"
export * from "./ContentNode.vue?vue&type=script&lang=js"
import style0 from "./ContentNode.vue?vue&type=style&index=0&id=065c2ad6&prod&lang=css"
import style1 from "./ContentNode.vue?vue&type=style&index=1&id=065c2ad6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065c2ad6",
  null
  
)

export default component.exports